import { IAttachment } from '@app/models/Attachment'
import { FileUploadAttachment } from '@app/models/FileUploadAttachment'
import { bindFunctions } from '@app/utils/class'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { List } from 'immutable'
import * as React from 'react'
import Select from 'react-select'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import CheckBox from '../../CheckBox'
import * as FileUploadState from '../modules/fileUpload'
import './FileUpload.scss'

interface IComponentProps {
  attachment: IAttachment
  identifier: string
  isOpen: boolean
  onCancel: () => void
  onSave: (e: IAttachment) => void
}

interface IComponentState {
  tags: any
  tagsList: any
}

type ComponentProps = IComponentProps &
  FileUploadState.IFileUploadState &
  typeof FileUploadState.actionCreators

export default class FileUploadModal extends React.PureComponent<
  ComponentProps,
  IComponentState
> {
  public constructor(props: ComponentProps) {
    super(props)

    this.state = {
      tags: [],
      tagsList: [
        {
          label: 'Survey',
          value: 1,
        },
        {
          label: 'Building Layout',
          value: 2,
        },
      ],
    }

    bindFunctions(this)
  }

  public componentWillMount() {
    this.props.loadExistingAttachments(
      this.props.identifier,
      List([this.props.attachment]),
      true,
    )
  }

  public componentWillReceiveProps(nextProps: ComponentProps) {
    // If the modal is opening
    if (nextProps.isOpen !== this.props.isOpen && nextProps.isOpen) {
      this.props.enableEditFileItem(
        new FileUploadAttachment({
          id: nextProps.attachment.id,
          key: nextProps.identifier,
        }),
      )
    }
  }

  public componentWillUnmount() {
    this.props.removeFileUploadItem(this.props.identifier, this.props.attachment.id)
  }

  public render() {
    return this.renderFileUploadModal()
  }

  private renderFileUploadModal() {
    const headerText = 'Edit File'

    let tags = this.state.tags
    if (this.props.currentFile) {
      if (Array.isArray(this.props.currentFile.attachment.tags)) {
        tags = this.props.currentFile.attachment.tags.map((item, index) => {
          return {
            label: item,
            value: index ? index + 1 : 1,
          }
        })
      } else {
        tags = this.props.currentFile.attachment.tags
          .map((item, index) => {
            return {
              label: item,
              value: index ? index + 1 : 1,
            }
          })
          .toJS()
      }
    }

    return (
      <Modal isOpen={this.props.isOpen}>
        <ModalHeader>{headerText}</ModalHeader>
        <ModalBody>
          {this.props.currentFile && (
            <div className='d-flex flex-column'>
              {this.renderImage()}
              <div className='form-group'>
                <label>Title</label>
                <input
                  className='form-control'
                  type='text'
                  value={this.props.currentFile.attachment.title}
                  onChange={(e) => this._editFileTitle(e.target.value)}
                />
              </div>

              <div className='form-group'>
                <label>Description (optional)</label>
                <textarea
                  className='form-control'
                  value={this.props.currentFile.attachment.description}
                  onChange={(e) => this._editFileDescription(e.target.value)}
                />
              </div>

              <div className='form-group'>
                <label>Tags</label>
                <Select
                  name='tags-list'
                  value={tags}
                  isMulti
                  options={this.state.tagsList}
                  onChange={(e: any) => {
                    this.setState({ tags: e })
                    this._editTagList(e.map((item: any) => item.label))
                  }}
                />
              </div>

              <div className='form-group'>
                <CheckBox
                  onChange={(newValue) => this._editMakePublic(newValue)}
                  value={this.props.currentFile.attachment.isPublic}
                >
                  Make public
                </CheckBox>
              </div>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            color='secondary'
            onClick={() => {
              this._cancelCurrentFile()
              this.setState({
                tags: [],
              })
            }}
          >
            Cancel
          </Button>
          <Button
            color='primary'
            onClick={() => {
              this._editFile(
                this.props.currentFile.attachment,
                this.props.isInEditMode,
              )
              this.setState({
                tags: [],
              })
            }}
          >
            {this.props.isInEditMode ? 'Save' : 'Upload'}
          </Button>
        </ModalFooter>
      </Modal>
    )
  }

  private _cancelCurrentFile() {
    this.props.cancelCurrentFile()
    this.props.onCancel()
  }

  private _editFile(file: IAttachment, editMode: boolean) {
    this.props.updateFileMetadata()
    this.props.onSave(file)
  }

  private _editFileDescription(value: string) {
    this.props.editFileDescription(value)
  }

  private _editTagList(value: List<string>) {
    this.props.editTagList(value)
  }

  private _editMakePublic(value: boolean) {
    this.props.editMakePublic(value)
  }

  private _editFileTitle(value: string) {
    this.props.editFileTitle(value)
  }

  private renderImage() {
    return (
      <div style={{ textAlign: 'center' }}>
        <FontAwesomeIcon
          icon={['fal', 'file']}
          style={{ height: '100px', fontSize: '5rem' }}
        />
      </div>
    )
  }
}
